<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.38235 2.84098C9.70189 2.9266 9.89152 3.25504 9.8059 3.57458L7.35121 12.7356C7.2656 13.0551 6.93715 13.2447 6.61761 13.1591C6.29808 13.0735 6.10845 12.7451 6.19407 12.4255L8.64875 3.26452C8.73437 2.94499 9.06282 2.75536 9.38235 2.84098Z"
    />
  </svg>
</template>
